<monitors-filter #monitorFilter [(nameFilter)]="monitorsNameFilterExpression" [(viewMode)]="viewMode"
  [(locationFilter)]="locationFilterExpression">
  <ng-content></ng-content>
</monitors-filter>

@let monitorsFilteredByTag = screens | monitorTagFilter | async;
@let monitorsFilteredByMonitorFilter = monitorsFilteredByTag | monitorFilter: monitorFilter.location: monitorFilter.nameFilter: monitorFilter.categoryFilter;
@let monitorsFilteredByPagination = monitorsFilteredByMonitorFilter | paginatorFilter: selectedPage: itemsPerPage: viewMode;

@if (viewMode === viewModes.List && monitorsFilteredByPagination.length) {
  <div class="row no-gutters list-controls">
    <div class="col-12 d-flex align-items-center">
      <mat-checkbox
        class="mr-4"
        matTooltip="Select All Monitors"
        [checked]="selectedScreens | allMonitorsChecked: monitorsFilteredByPagination"
        (change)="onSelectAllMonitorsChanged($event.checked)">
        Select All
      </mat-checkbox>

      <ng-select [(ngModel)]="selectedStartOption" [multiple]="false" [items]="startOptions" [searchable]="false"
        [readonly]="!selectedScreens.length" (click)="$event.stopPropagation()" [markFirst]="false" [closeOnSelect]="true"
        [clearable]="false" placeholder="Select Start Option" (change)="refreshStartOptions($event)">
        <ng-template ng-label-tmp let-item="item">
          {{ item ? 'Playlist' : 'Default' }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <span>{{ item ? 'Playlist' : 'Default' }}</span>
        </ng-template>
      </ng-select>

      <div class="d-flex align-items-center ml-auto sort-monitor-list">
        <mat-icon matTooltip="Sort By" matSuffix svgIcon="sort" class="mr-1"></mat-icon>
        <mat-select [(ngModel)]="monitorSortingMode" name="monitor-select" [disableOptionCentering]="true" panelClass="mat-sort-select">
          <mat-option [value]="monitorSortingModes.SortByMonitorTitle">
            Monitor Title
          </mat-option>
          <mat-option [value]="monitorSortingModes.SortByLocationTitle">
            Location Title
          </mat-option>
        </mat-select>
      </div>
    </div>
  </div>
}

<div class="selection-area"
  [ngStyle]="{'overflow': isScreenDataLoaded ? 'auto' : 'hidden'}"
  [class.selection-area]="!(viewMode === viewModes.FullScreen)"
  [class.list-view]="viewMode === viewModes.List"
  [class.monitors-view]="screens.length && (viewMode==viewModes.MonitorsSmall || viewMode==viewModes.Monitors)"
  #selectContainer>

  <ng-container *ngIf="isScreenDataLoaded && !screens.length">
    <div class="warning-card">
      <div class="warning-card-wrapper">
        <div class="warning-card-icon">
          <span *ngIf="isRedirecting; else warningIcon" class="warning-card-loader"></span>
          <ng-template #warningIcon>
            <mat-icon class="playlist-icon" svgIcon="priority_high"></mat-icon>
          </ng-template>
        </div>
      </div>
      <p>There are no agents currently<br>connected to the system.<br>
        <ng-container *ngIf="(administratorRole | isInRole) || (categoryManagerRole | isInRole)">
          <a [routerLink]="['/Admin/Info']" (click)="isRedirecting = true">Click here</a> to manage the agents.
        </ng-container>
      </p>
    </div>
  </ng-container>

  <ng-container *ngIf="viewMode==viewModes.MonitorsSmall || viewMode==viewModes.Monitors">
    <div *ngIf="monitorsFilteredByPagination.length" class="text-center text-md-left dragula h-100">
      <monitor
        *ngFor="let screen of monitorsFilteredByPagination; trackBy: trackScreen"
        class="monitor-thumbnail" [monitor]="screen" [viewMode]="viewMode"
        id="{{screen.MachinePhysicalAddress}}:{{screen.MonitorHandler}}" [clickOutside]="selectedItems"
        [parentComponent]="selectContainer" cdkDropList (cdkDropListDropped)="drop($event)"
        data-selection-type="monitor" (viewModeChanged)="viewMode = $event"
        [class.biggerMonitor]="viewMode === viewModes.Monitors">
      </monitor>
    </div>
  </ng-container>

  <ng-container *ngIf="viewMode==viewModes.FullScreen">
    <ng-container *ngIf="remoteControlMonitorKey; else monitorFullScreen">
      <div class="selected-full-screen text-center position-relative overflow-hidden">
        <monitor-remote-control [remoteControlMonitor]="remoteControlMonitor" [monitorKey]="remoteControlMonitorKey">
        </monitor-remote-control>
      </div>
    </ng-container>

    <ng-template #monitorFullScreen>
      <div *ngIf="screens.length" class="h-100 dragula">
        <item-view-full-screen [viewMode]="viewMode" [monitorFilter]="monitorFilter.nameFilter"
          [screens]="monitorsFilteredByMonitorFilter"
          [locations]="monitorFilter.locations"></item-view-full-screen>
      </div>
    </ng-template>
  </ng-container>

  <ng-container *ngIf="viewMode==viewModes.List">
    <div class="list-container dragula" *ngIf="monitorsFilteredByPagination.length">
      <list-item
        *ngFor="let screen of monitorsFilteredByPagination | monitorSort: monitorSortingMode; trackBy: trackScreen"
        [monitor]="screen" [idPlaylist]="screen.IdAssignedPlaylist" [clickOutside]="selectedItems"
        data-selection-type="monitor" [parentComponent]="selectContainer"
        id="{{screen.MachinePhysicalAddress}}:{{screen.MonitorHandler}}">
      </list-item>
    </div>
  </ng-container>

  <ng-container *ngIf="viewMode==viewModes.Calendar">
    <div class="row no-gutters px-2 align-items-center mb-3 w-100">
      <div class="d-flex align-items-center sort-monitor-list">
        <mat-icon matTooltip="Schedule options" matSuffix svgIcon="schedule" class="mr-1"></mat-icon>
        <mat-select [(ngModel)]="calendarViewMode" (selectionChange)="changeTitle()" name="monitor-select"
          [disableOptionCentering]="true" panelClass="mat-sort-select">
            @for (mode of calendarViewModes | keyvalue: originalOrder; track $index) {
              <mat-option [value]="mode.value">
                {{ mode.key }}
              </mat-option>
            }
        </mat-select>
      </div>
    </div>

    <div class="timeline-container" *ngIf="screens.length">
      <div class="timeline-head">
        <mat-icon matTooltip="Previous {{ calendarViewMode }}" class="left-arrow day-change-arrow" svgIcon="arrow_back"
          (click)="onCalendarBackward()"></mat-icon>
        <span>{{calendarTitle}}</span>
        <mat-icon matTooltip="Next {{ calendarViewMode }}" svgIcon="arrow_forward" class="right-arrow day-change-arrow"
          (click)="onCalendarForwards()">
        </mat-icon>
      </div>
      <timeline [date]="date" [monitorFilter]="monitorFilter.nameFilter"
        [calendarMode]="calendarViewMode"
        [screens]="monitorsFilteredByMonitorFilter"
        [locations]="monitorFilter.locations"> </timeline>
    </div>
  </ng-container>

  <div class="monitors-skeleton-loader" *ngIf="!isScreenDataLoaded">
    <div class="monitors-skeleton-loader-container">
      <div class="cards" *ngFor="let i of skeletonMonitorsArr">
        <div class="card-monitor loading">
          <div class="card-monitor-checkbox"></div>
          <div class="card-monitor-title"></div>
        </div>
      </div>
    </div>
  </div>

</div>

<pagination
  *ngIf="screens.length && (viewMode==viewModes.MonitorsSmall || viewMode==viewModes.Monitors || viewMode==viewModes.List)"
  [totalItems]="(filteredMonitors$ | async)?.length"
  [itemsPerPage]="itemsPerPage"
  [currentPage]="selectedPage"
  (pageChanged)="onPageChange($event)">
</pagination>

<div [@openClose]="!isBottomPanelVisible ? 'open' : 'closed'" class="d-none d-sm-block setting-button">
  <mat-icon svgIcon="bottom-menu-settings" matTooltip="Open Quick Launch Panel" (click)="uiService.showBottomPanel()"></mat-icon>
</div>
